import "./footer.scss";

export default ({ ...rest }) => {
  return <footer className={"footer"} {...rest} />;
};
